import React from 'react'

export const ModalButton = props => {
  const { classes } = props

  const getClassName = () => {
    if (props.variant === 'attention') {
      return classes.attention
    }
    if (props.variant === 'primary') {
      return classes.primary
    }

    return classes.cancel
  }

  return (
    <button className={`${getClassName()} ${classes.button}`} {...props}>
      {props.children}
    </button>
  )
}
